import { useEffect, useState } from "react";
import is from "@sindresorhus/is";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import Heading from "../Heading/Heading";

import actions from "../../../data/actions";

const Feedbacks = props => {
  const theme = useTheme();

  const [posts, setPosts] = useState();

  const bgcolor = theme.palette.background.paper;
  const color = theme.palette.getContrastText(bgcolor);

  // (init) -> posts
  useEffect(() => {
    Promise.resolve()
      .then(() => actions.getFeedbackPosts())
      .then(posts => setPosts(posts))
      .catch(error => console.log(error));
  }, []);

  return (
    <>
      {is.array(posts) && (
        <>
          <Paper elevation={0} square sx={{ bgcolor, color }}>
            <Container disableGutters maxWidth="lg" sx={{ pt: 4, pb: 8, px: 2 }}>
              <Heading label={"Rólunk mondták"} sx={{ pb: 4 }} />
              <Grid container spacing={8}>
                {posts.map((post, index) => (
                  <Grid item key={post.id} xs={12} sm={6}>
                    <Box>
                      <Typography sx={{ color: theme.palette.primary.main, fontStyle: "italic" }}>{post.title}</Typography>
                      <Typography sx={{ color: theme.palette.text.primary }}>{post.excerpt.plain}</Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Paper>
        </>
      )}
    </>
  );
};

export default Feedbacks;
